import { CONTACTS } from "./constance";
import Icon from "../../common/Icon";

function ContactFooter() {
  return (
    <div className="md:order-3">
      <h4 className="flex items-center gap-2 text-lg font-black text-white">
        <span className="h-5 w-1 rounded-full bg-floodlight" />
        ارتباط با ما
      </h4>

      <ul className="mt-5 space-y-3">
        {CONTACTS.map((c) => (
          <li key={c.label}>
            <a
              href="#"
              className="group flex items-center gap-3 text-sm text-white/65 transition-colors hover:text-white"
            >
              <span className="grid h-10 w-10 place-items-center rounded-full border border-white/10 bg-white/5 text-floodlight transition-all group-hover:bg-floodlight group-hover:text-ink">
                <Icon name={c.icon} className="h-4 w-4" />
              </span>
              {c.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ContactFooter;
